const SERVICES_ITEMS = [
  { title: "Сверка 1С", url: "compare_1c" },
  { title: "Списание 1С", url: "sales_1c" },
  { title: "Обновление цен", url: "prices" },
  { title: "Выгрузка Emails", url: "emails", reportName: "special" },
  { title: "Переоценка", url: "revaluation" },
  { title: "Обновление тегов", url: "tag_sync" },
  { title: "Новые поступления", url: "refresh" },
  { title: "Замена артистов", url: "artist_change" },
  { title: "Цены на маркетах", url: "market_price" },
]

export const EDITOR_MENU_TOPOLOGY = Object.freeze([
  {
    id: "dashboard",
    title: "Дашборд",
    url: "",
    visibility: "authenticated",
    menu: false,
  },
  {
    id: "modules",
    title: "Модули",
    url: "modules",
    visibility: "modules",
    childrenOwner: "store.menuModules",
  },
  { id: "users", title: "Пользователи", url: "users", visibility: "block" },
  { id: "pages", title: "Страницы", url: "pages", visibility: "block" },
  { id: "options", title: "Параметры", url: "options", visibility: "block" },
  {
    id: "access",
    title: "Доступ",
    url: "access",
    visibility: "access.manage",
  },
  { id: "reports", title: "Отчёты", url: "reports", visibility: "block" },
  { id: "seo", title: "SEO", url: "seo", visibility: "block" },
  { id: "carts", title: "Корзины", url: "carts", visibility: "block" },
  {
    id: "services",
    title: "Сервисы",
    url: "services",
    visibility: "block",
    subItems: SERVICES_ITEMS,
  },
])
